import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-aviation bg-white py-5 sm:py-7" data-id="element-39" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-40" data-mp="8448n0mpwlbn">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-4xl" data-id="element-41" data-mp="m4yk5s52b2ej">
          ONE LAST <span className="text-aviation" data-id="element-42" data-mp="m2lustwz5prg">QUESTION</span>
        </h2>
        <div className="mx-auto mt-1.5 max-w-3xl space-y-1 text-center text-sm leading-snug text-graphite sm:text-base" data-id="element-43" data-mp="h5c65gheti4o">
          <p data-id="element-44" data-mp="vwunbhm09ipm">
            When you're studying aircraft systems, trying to interpret cockpit instruments,
            understanding aerodynamics, reviewing airspace, or working through aviation weather
            and navigation concepts...
          </p>
          <p data-id="element-45" data-mp="zxefs7vmvy5f">
            Do you have one organized visual learning system that helps you see the concepts,
            connect the information, and understand what you're studying?
          </p>
          <p data-id="element-46" data-mp="2h4ssiow2a5xh">
            Stop relying entirely on scattered diagrams, disconnected aviation explanations, and
            endless searches for visual study references.
          </p>
          <p data-id="element-47" data-mp="2r2gpllh53pit">
            <strong className="font-semibold text-navy" data-id="element-48" data-mp="2r2yroyqhgxyn">
              See the systems. Understand the instruments. Visualize the principles. Study
              aviation with clarity.
            </strong>
          </p>
        </div>

        <MockupImage className="mt-2" data-id="element-49" data-mp="300sp6czzhxne" />

        <div className="mt-2 text-center" data-id="element-50" data-mp="34tloglcoods3">
          <p className="font-display text-xl font-extrabold uppercase leading-none text-navy sm:text-3xl" data-id="element-51" data-mp="34tu6ernny9a5">
            ✈️ {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-graphite sm:text-base" data-id="element-52" data-mp="3errsb8i1vtzl">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-[11px] font-bold uppercase tracking-wide text-aviation sm:text-sm" data-id="element-53" data-mp="1joczkidfp7yn">
            Study • Visualize • Understand • Interpret • Practice • Review
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-54" data-mp="1sh6svjppu7vi">
          <p className="mb-2 text-center font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-55" data-mp="1sirm960ankrs">
            🔥 GET THE COMPLETE SYSTEM TODAY — <span className="text-aviation" data-id="element-56" data-mp="22ds0mct4dx31">$27 USD</span>
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-57" data-mp="1xg04f6lfzot1">✈️ GET {PRODUCT}</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-58" data-mp="1xhuko7lrqsqs" />
        </div>
      </div>
    </section>;
}